import React from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import './index.css';
import { ChatPlatformProvider } from './chat-platform/context/ChatPlatformContext';
import { connect } from './chat-platform/store/websocketSlice';

function App() {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(connect());
    }, [dispatch]);

    return (
        <ChatPlatformProvider>
            <div className="App h-screen">
                <Outlet />
            </div>
        </ChatPlatformProvider>
    );
}

export default App;